
import Vue from 'vue';
import ServerAddress from "@/views/login/partials/ServerAddress.vue";

export default Vue.extend({
  name: "SelectServerName",
  components: {ServerAddress},
  data() {
    return {
      triggerFn: () => {},
    }
  },
})
